import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { io } from 'socket.io-client';

/**
 * {
 * message: string,
 * id: string,
 * progress: number | undefined,
 * title: string | undefined,
 * timeout: number
 * cancellable: boolean,
 * }
 */

export const pageAppSlice = createSlice({
    name: 'pageApp',
    initialState: {
        app: {},
        components: [],
        queries: [],
        globals: [],
        pageContext: {},
    },
    reducers: {
        setApp: (state, action) => {
            state.app = action.payload;
        },
        setComponents: (state, action) => {
            state.components = action.payload;
        },
        setQueries: (state, action) => {
            state.queries = action.payload;
        },
        setComponentPropertyValue: (state, action) => {
            const { componentId, propertyId, value } = action.payload;
            const components = state.components;
            for (let i = 0; i < components.length; i++) {
                if (components[i].id === componentId) {
                    const properties = components[i].properties;
                    for (let j = 0; j < properties.length; j++) {
                        if (properties[j].id === propertyId) {
                            properties[j].value = value;
                            break;
                        }
                    }
                    break;
                }
            }
            state.components = [...components];
        },
        setQueryPropertyValue: (state, action) => {
            const { queryId, propertyId, value } = action.payload;
            const queries = state.queries;
            for (let i = 0; i < queries.length; i++) {
                if (queries[i].id === queryId) {
                    const properties = queries[i].properties;
                    for (let j = 0; j < properties.length; j++) {
                        if (properties[j].id === propertyId) {
                            properties[j].value = value;
                            break;
                        }
                    }
                    break;
                }
            }
            state.queries = [...queries];
        },
        setComponentState: (state, action) => {
            const { componentId, stateId, value } = action.payload;
            const components = state.components;
            for (let i = 0; i < components.length; i++) {
                if (components[i].id === componentId) {
                    components[i].state[stateId] = value;
                    break;
                }
            }
            state.components = [...components];
        },
        runQuery: (state, action) => {
            const { queryId } = action.payload;
            const queries = state.queries;
            for (let i = 0; i < queries.length; i++) {
                if (queries[i].id === queryId) {
                    queries[i].state.loading = true;
                    break;
                }
            }
            state.queries = [...queries];
        },
        updateQueryState: (state, action) => {
            const { queryId, data } = action.payload;
            const queries = state.queries;
            for (let i = 0; i < queries.length; i++) {
                if (queries[i].id === queryId) {
                    Object.keys(data).forEach((key) => {
                        queries[i].state[key] = data[key];
                    });
                    break;
                }
            }
            state.queries = [...queries];
        },
        setPageContext: (state, action) => {
            state.pageContext = { ...action.payload };
        },
        sendEvent: (state, action) => {

        },
    },
});

// Action creators are generated for each case reducer function
export const {
    setApp,
    setComponents,
    setQueries,
    setComponentState,
    setPageContext,
    runQuery,
    updateQueryState,
    sendEvent,
} = pageAppSlice.actions;

export default pageAppSlice.reducer;
